<template>
  <div class="debug-view">
    <h1>Debug View</h1>
    <p>This is a simple test component to verify routing is working.</p>
    <p>Current route: {{ $route.path }}</p>
    <p>Current time: {{ new Date().toLocaleTimeString() }}</p>
    
    <!-- Notification Testing -->
    <div class="notification-testing">
      <h2>Notification Testing</h2>
      <div class="test-buttons">
        <Button @click="testInfo" variant="primary">Test Info</Button>
        <Button @click="testSuccess" variant="primary">Test Success</Button>
        <Button @click="testWarning" variant="primary">Test Warning</Button>
        <Button @click="testError" variant="primary">Test Error</Button>
        <Button @click="testExpandable" variant="secondary">Test Expandable</Button>
      </div>
    </div>
    
    <AuthDebug />
  </div>
</template>

<script setup lang="ts">
import AuthDebug from '@/components/debug/AuthDebug.vue'
import Button from '@/components/atoms/Button.vue'
import { useNotifications } from '@/composables/useNotifications'

const { info, success, warning, error } = useNotifications()

const testInfo = () => {
  info('This is an info notification', {
    source: 'Debug View',
    timeout: 5000
  })
}

const testSuccess = () => {
  success('Operation completed successfully!', {
    source: 'Debug View',
    timeout: 5000
  })
}

const testWarning = () => {
  warning('This is a warning message', {
    source: 'Debug View',
    timeout: 5000
  })
}

const testError = () => {
  error('An error occurred while processing your request', {
    source: 'Debug View',
    timeout: 5000
  })
}

const testExpandable = () => {
  error('Database connection failed after 30 seconds. Connection timeout exceeded. Please check your network connection and try again. If the problem persists, contact your system administrator for further assistance.', {
    source: 'Database Service',
    timeout: 5000,
    expandable: true,
    actions: {
      primary: [
        { id: 'retry', label: 'Retry Connection', onClick: () => alert('Retrying...') }
      ],
      secondary: [
        { id: 'settings', label: 'Connection Settings', onClick: () => alert('Opening settings...') }
      ]
    }
  })
}
</script>

<style scoped>
.debug-view {
  padding: 24px;
  background: var(--vscode-editor-background);
  color: var(--vscode-foreground);
}

.debug-view h1,
.debug-view h2 {
  color: var(--vscode-foreground);
  margin-bottom: 16px;
}

.debug-view p {
  margin-bottom: 8px;
}

.notification-testing {
  margin: 24px 0;
  padding: 16px;
  border: 1px solid var(--vscode-widget-border);
  border-radius: 4px;
}

.test-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Test buttons styling removed - using standard Button component variants */
</style>
